<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
        <div class="columns">
            <div class="column is-half">
                <b-field label="Nombre">
                    <b-input
                    max="60"
                    required
                    v-model="userObj.firstName"
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Apellido">
                    <b-input
                    max="60"
                    required
                    v-model="userObj.lastName"
                    >
                    </b-input>
                </b-field>
            </div>
        </div>
        <div class="columns">
            <div class="column is-half">
                <b-field label="Direccion">
                    <b-input
                    v-model="details.address"
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Numero de telefono">
                    <b-input
                    v-model="details.phoneNumber"
                    >
                    </b-input>
                </b-field>
            </div>
        </div>
        <div class="columns">
            <div class="column is-half">
                <b-field autocomplete="off" label="Buscar pais">
                    <b-autocomplete
                        autocomplete="none"
                        v-model="details.countryName"
                        icon="search"
                        field="name"
                        :data="countries"
                        :loading="loadingCountries"
                        @input="fetchCountries"
                        @select="option => {
                            details.country = option.id
                            details.countryName = option.name
                        }"
                    >
                    <template slot-scope="props">
                    <p>{{props.option.name}}</p>
                    </template>
                    <template slot="empty">No country found...</template>
                    </b-autocomplete>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Ciudad">
                    <b-input
                    v-model="details.city"
                    >
                    </b-input>
                </b-field>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <b-field>
                    <p class="control">
                        <b-select v-model="details.idType">
                            <option value="">Document type</option>
                            <option value="CI">CI</option>
                            <option value="P">Passport</option>
                            <option value="O">Other</option>
                        </b-select>
                    </p>
                    <b-input 
                    v-model="details.idNumber"
                    placeholder="Document number" 
                    expanded
                    >
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns m-t-30">
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                :loading="saveLoading"
                @click="saveData">
                    <b-icon
                    icon="save"
                    size="is-small">
                    </b-icon>
                    Guardar perfil
                </b-button>
            </div>
        </div>

    </div>
</template>

<script>
import {getHandler, patchHandler, debounce} from "./../../../services/http.js"

export default {
    name: "Profile",
    props:{
        profileEndpoint:{
            type:String,
            default:""
        },
        countryList:{
            type:String,
            default:""
        },
        user:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            countries:[],
            loadingCountries:false,
            loading:false,
            details:{},
            userObj:{},
            saveLoading:false
        }
    },
    methods:{
        fetchCountries: debounce(
            async function(){
                this.loadingCountries = true
                let url = `${this.countryList}?country=${this.details.countryName}`
                let resp = await getHandler(url, {err:false, success:false})
                this.countries = resp
                this.loadingCountries = false
            },
            500
        ),
        async fetchDetails(){
            this.loading = true
            let resp = await getHandler(this.profileEndpoint, {error:false, success:false})
            this.details = resp
            this.loading = false
        },
        async fetchUser(){
            this.loading = true
            let resp = await getHandler(this.user, {error:false, success:false})
            this.userObj = resp
            this.loading = false
        },
        async saveData(){
            this.saveLoading = true
            let msg = {
                resource:'notify'
            }
            let resp1 = await patchHandler(this.profileEndpoint, this.details, {error:msg, success:msg})
            let resp2 = await patchHandler(this.user, this.userObj, {error:msg, success:msg})
            this.saveLoading = false
            this.details = resp1.data
            this.userObj = resp2.data
        }
    },
    created(){
        this.fetchDetails()
        this.fetchUser()
    }
}
</script>

<style lang="scss">
@import "./../../../scss/main.scss";
</style>